import React, { useEffect } from "react";

import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import ImageAside from "../../components/image-aside/Image-aside";
import "./PropertyTypes.css";
import { lendingImage, tinyLendingImage } from "../../assets";


const textContents = {
  title: "",
  paragraph:"",
  callToAction: "",
};



export default function PropertyTypes() {

  return (
    <div>
      <PageNameBanner pageName="Property Types" />
      <div className="propertyTypes">
        <ImageAside
          mainText={textContents.title}
          mainParagraph={textContents.paragraph}
          imageSrc={lendingImage}
          tinyImageSrc={tinyLendingImage}
          buttonText={textContents.callToAction}
          buttonEventHandler={() => {}}
        >
          <div>
            <h2>Property Types</h2>
            <ul>
              <li>Multi-family / Apartment buildings</li>
              <li>Hospitality</li>
              <li>Gas Station</li>
              <li>Mixed-use properties</li>
              <li>Commercial and retail co-ops and condominiums</li>
              <li>Retail / Shopping Centers</li>
              <li>Office buildings</li>
              <li>Warehouse / Industrial</li>
              <li>Self-storage</li>
              <li>Net-leased</li>
              <li>Owner-occupied</li>
              <li>Cannabis-related properties</li>
              <li>Land</li>
            </ul>
          </div>
        </ImageAside>
      </div>
    </div>
  );
}
